import type { RouteObject } from "react-router-dom";

// Chargement différé : chaque page devient un chunk séparé (code-splitting).
// `lazy` est auto-importé (voir vite.config.ts / eslint.config.ts).
const NotFound = lazy(() => import("../pages/NotFound"));
const Home = lazy(() => import("../pages/home/page"));
const MentionsLegales = lazy(() => import("../pages/mentions-legales/page"));
const PolitiqueConfidentialite = lazy(
  () => import("../pages/politique-confidentialite/page"),
);
const HotelleriePage = lazy(() => import("../pages/hotellerie-restauration/page"));
const BTPPage = lazy(() => import("../pages/btp-securite/page"));
const MobilitePage = lazy(() => import("../pages/mobilite-flotte-pro/page"));
const EnergiePage = lazy(() => import("../pages/energie-environnement/page"));
const CommercePage = lazy(() => import("../pages/commerce-retail/page"));
const PMEPage = lazy(() => import("../pages/pme-tpe/page"));
const SantePage = lazy(() => import("../pages/sante-bien-etre/page"));
const SportPage = lazy(() => import("../pages/sport-loisirs-culture/page"));
const AgriculturePage = lazy(() => import("../pages/agriculture-peche/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/politique-confidentialite",
    element: <PolitiqueConfidentialite />,
  },
  {
    path: "/thematiques/hotellerie-restauration",
    element: <HotelleriePage />,
  },
  {
    path: "/thematiques/btp-securite",
    element: <BTPPage />,
  },
  {
    path: "/thematiques/mobilite-flotte-pro",
    element: <MobilitePage />,
  },
  {
    path: "/thematiques/energie-environnement",
    element: <EnergiePage />,
  },
  {
    path: "/thematiques/commerce-retail",
    element: <CommercePage />,
  },
  {
    path: "/thematiques/pme-tpe",
    element: <PMEPage />,
  },
  {
    path: "/thematiques/sante-bien-etre",
    element: <SantePage />,
  },
  {
    path: "/thematiques/sport-loisirs-culture",
    element: <SportPage />,
  },
  {
    path: "/thematiques/agriculture-peche",
    element: <AgriculturePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
